import createIcon from '../../createIcon';

/**
 * @component @name EditCalendar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuOTMzNiAyMS41SDMuOTMzNTlDMi44MjM1OSAyMS41IDEuOTMzNTkgMjAuNiAxLjkzMzU5IDE5LjVMMS45NDM1OSA1LjVDMS45NDM1OSA0LjQgMi44MjM1OSAzLjUgMy45MzM1OSAzLjVINC45MzM1OVYxLjVINi45MzM1OVYzLjVIMTQuOTMzNlYxLjVIMTYuOTMzNlYzLjVIMTcuOTMzNkMxOS4wMzM2IDMuNSAxOS45MzM2IDQuNCAxOS45MzM2IDUuNVYxMS41SDE3LjkzMzZWOS41SDMuOTMzNTlWMTkuNUgxMC45MzM2VjIxLjVaTTIxLjA2MzYgMTYuNDlMMjEuNzczNiAxNS43OEMyMi4xNjM2IDE1LjM5IDIyLjE2MzYgMTQuNzYgMjEuNzczNiAxNC4zN0wyMS4wNjM2IDEzLjY2QzIwLjY3MzYgMTMuMjcgMjAuMDQzNiAxMy4yNyAxOS42NTM2IDEzLjY2TDE4Ljk0MzYgMTQuMzdMMjEuMDYzNiAxNi40OVpNMjAuMzUzNiAxNy4yTDE1LjA1MzYgMjIuNUgxMi45MzM2VjIwLjM4TDE4LjIzMzYgMTUuMDhMMjAuMzUzNiAxNy4yWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditCalendar = createIcon('EditCalendar', [
  [
    'path',
    {
      d: 'M10.9336 21.5H3.93359C2.82359 21.5 1.93359 20.6 1.93359 19.5L1.94359 5.5C1.94359 4.4 2.82359 3.5 3.93359 3.5H4.93359V1.5H6.93359V3.5H14.9336V1.5H16.9336V3.5H17.9336C19.0336 3.5 19.9336 4.4 19.9336 5.5V11.5H17.9336V9.5H3.93359V19.5H10.9336V21.5ZM21.0636 16.49L21.7736 15.78C22.1636 15.39 22.1636 14.76 21.7736 14.37L21.0636 13.66C20.6736 13.27 20.0436 13.27 19.6536 13.66L18.9436 14.37L21.0636 16.49ZM20.3536 17.2L15.0536 22.5H12.9336V20.38L18.2336 15.08L20.3536 17.2Z',
      key: 'bab61v',
    },
  ],
]);

export default EditCalendar;
